import { render, staticRenderFns } from "./TcKimlikNumarasi.vue?vue&type=template&id=52b38ef2"
import script from "./TcKimlikNumarasi.vue?vue&type=script&lang=ts"
export * from "./TcKimlikNumarasi.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports